// JsFromRoutes CacheKey 8047b40fc83f9449c650e91a4296930d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/my-account/gift-lists'),
  show: /* #__PURE__ */ definePathHelper('get', '/my-account/gift-lists/:id'),
}
